module.exports = __webpack_public_path__ + "static/media/freight-box.fb974335.svg";